import LoginPage from './LoginPage';
import ForgotPasswordPage from './ForgotPasswordPage';

export {LoginPage, ForgotPasswordPage};


/** WEBPACK FOOTER **
 ** ./src/modules/customer/components/index.js
 **/